module.exports = __webpack_public_path__ + "static/competition-hots-up-6feee1c0bb068e516f3d6eae5ca936e3.png";